import { Button as ButtonClass } from './style.styl'

function ViewAllAttributesButton({ onClick }) {
  return (
    <div className={`${ButtonClass} flex-center`} onClick={onClick}>
      <img
        src={require('images/svg/rolodex-navy.svg')}
        style={{ width: 16, height: 11, marginRight: 7 }}
      />
      <span className="dsg-Body">View all attributes</span>
    </div>
  )
}

export default ViewAllAttributesButton



// WEBPACK FOOTER //
// ./src/scripts/components/customer/EndUserAttributesCard/ViewAllAttributesButton/index.js